export const maySaveRestriction = ({
    hasSubject,
    hasExclusions,
    isDuplicateSubject,
    hasUnaddedStudentGroup
}) =>
    Boolean(hasSubject) &&
    Boolean(hasExclusions) &&
    !isDuplicateSubject &&
    !hasUnaddedStudentGroup;
